import React, { useState } from "react";
import { aboutDetail } from "../../utils/about-details";
import ImageCards from "../common/components/about/ImageCards";
import Hero from "../common/components/Hero";
import OurServices from "../common/components/our-services/OurServices";
import BlueTag from "../common/ui/BlueTag";
import Heading from "../common/ui/Heading";
import Paragraph from "../common/ui/Paragraph";
import Gallery from "../home/Gallery";
import Innovate from "../home/Innovate";

const Consultancy = () => {
  const [list, setList] = useState(aboutDetail["india-consultancy"]);

  return (
    <div>
      <Hero value={3} />
      {list.about && (
        <div className="bg-white pt-10 sm:pt-14 md:pt-20 lg:pt-24 pb-14 sm:pb-16 md:pb-24 lg:pb-28 xl:pb-[120px]">
          <div className="container mx-auto max-lg:px-3.5 max-md:px-6">
            <div className="flex max-xl:flex-col gap-y-8 gap-x-[57px]">
              <div className="max-lg:max-w-[714px] xl:max-w-[500px] 2xl:max-w-[700px] w-full mx-auto 2xl:ml-0">
                <BlueTag>About us</BlueTag>

                <Heading className="pt-1 max-xl:mx-auto xl:max-w-[456px] 2xl:max-w-[600px]">
                  {list.about.title}
                </Heading>

                {list.about.description.map((detail, index) => (
                  <Paragraph
                    key={index}
                    className="pt-3 max-w-[778px] xl:max-w-[500px] 2xl:max-w-[600px]"
                  >
                    {detail}
                  </Paragraph>
                ))}

                {list.author && (
                  <div className="flex items-center gap-x-3 mt-3 md:mt-5">
                    <img
                      src={list.author.img}
                      alt="author"
                      className="size-11 object-cover rounded-full overflow-clip"
                    />
                    <div>
                      <h3 className="text-custom-dark-blue text-sm font-semibold !leading-133">
                        {list.author.name}
                      </h3>
                      <p className="text-xs !leading-155 font-normal pt-1 text-custom-dark-blue">
                        {list.author.role}
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="lg:max-h-[500px] flex grow xl:max-w-[583px] 2xl:max-w-[42%]">
                <ImageCards detail={list.about.second} />
              </div>
            </div>
          </div>
        </div>
      )}
      {list.gallery && <Gallery imgList={list.gallery} />}
      <OurServices serviceList={list.services} />
      <Innovate />
    </div>
  );
};

export default Consultancy;
